import { render, staticRenderFns } from "./CompanyAccounts.vue?vue&type=template&id=52c3834b&scoped=true&"
import script from "./CompanyAccounts.vue?vue&type=script&lang=js&"
export * from "./CompanyAccounts.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAccounts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CompanyAccounts.vue?vue&type=style&index=1&id=52c3834b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3834b",
  null
  
)

component.options.__file = "CompanyAccounts.vue"
export default component.exports